import { useState, useEffect } from 'react'

export const useExtraIncomeValue = (goToNextScreen, incomeStatementPath, setDataModal) => {
  const [values, setValues] = useState({})
  const [isButtonDisabled] = useState(false)

  useEffect(() => {
    setDataModal(null)
  }, [setDataModal])

  useEffect(() => {
    if (
      incomeStatementPath &&
      incomeStatementPath.readExtraIncomeValue &&
      incomeStatementPath.readExtraIncomeValue.length > 0
    ) {
      const data = {}
      incomeStatementPath.readExtraIncomeValue.map(item => {
        data[item.internalName] = {
          value: item.value,
          id: item.id
        }
      })
      setValues(data)
    }
  }, [incomeStatementPath])

  const onSubmit = e => {
    e.preventDefault()
    const keys = Object.keys(values)
    const result = keys.map(key => {
      return values[key]
    })
    goToNextScreen(result)
  }

  const onValueChange = (e, _, value, id, name) => {
    setValues({
      ...values,
      [name]: {
        value: value,
        id: id
      }
    })
  }
  return [onSubmit, onValueChange, values, isButtonDisabled]
}
